<template>
  <div class="jazeMainPanel" style="height: 100%;">
    <div class="jazePanelContent jazePanelContent--scrollable">
      <div class="unifiSettingsContainer">
        <form ref="locationConfigForm" id="locationConfigForm" class="appForm appForm--cozy is-validation-hidden" :class="formClass">
          <div class="unifiSettingsHeader">
            <div class="unifiSettingsHeader__title">Location Configuration</div>
          </div>
          <fieldset class="appFieldset appFieldset--quiet">
            <div class="jazeAlert jazeAlert--danger row col-12" v-if='errorShow'>
              <div class="col-6">
                <strong>{{errorMessage}}</strong>
              </div>
            </div>
            <div class="unifiSettingsSection">
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 1</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel1Name" autofocus="true" v-model="locationLevel1Name">
                </div>
              </div>
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 2</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel2Name" v-model="locationLevel2Name">
                </div>
              </div>
           
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 3</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel3Name" v-model="locationLevel3Name">
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <div class="appFormFooter appFormFooter--standalone appFormFooter--flush appFormFooter--dark">
          <div class="appFormFooter__right">
            <button class="appMainButton appMainButton--primary busyToggle" type="submit" @click="saveLocationConfig"> Save</button>
          </div>
        </div>
      </div>
    </div>
    <SuccessToaster :successMessage='successMessage' :sucesstoasterShow='successtoaster' v-if='successtoaster'></SuccessToaster>
    <ErrorToaster :errorMessage='errorMessage' :errortoasterShow='errortoaster' v-if='errortoaster'></ErrorToaster>
  </div>
</template>

<script setup>
import { ref,computed,watch,watchEffect,onMounted,onBeforeUnmount } from 'vue';
import Treeselect from "jaze-vue3-treeselect";
import SuccessToaster from "@/components/Toaster/SuccessToaster.vue";
import ErrorToaster from "@/components/Toaster/ErrorToaster.vue";
import moment from "moment";
import "moment-timezone";
import VueCtkDateTimePicker from "jaze-ctk-date-time-picker";

import { storeToRefs } from "pinia";
import {overrideIsSelected} from '@/overrides/vue3-treeselect'
import { uselayoutStore } from '@/store/layoutstore'
import { usesettingsStore } from '@/store/settingsstore'

    const genConfigDetails = ref( [] )
    const formClass = ref( "" )
    const errorShow = ref( false )
    const errorMessage = ref( "" )
      
    const successtoaster = ref( false )
    const successMessage = ref( "" )
    const errortoaster = ref( false )
    const locationLevel1Name = ref( "Area" )
    const locationLevel2Name = ref( "Street" )
    const locationLevel3Name = ref( "Building" )
   

    const settingsStore = usesettingsStore()
    const { locationConfigDetails } = storeToRefs(settingsStore)
    const locationConfigGetter = computed(() => locationConfigDetails.value);

    onMounted(() => {
      getLocationConfigDetails();
    })
    onBeforeUnmount(() => {
      settingsStore.clearSettingsState();
    })
    watch(locationConfigGetter,() => {
      genConfigDetails.value = locationConfigGetter.value;
      
      if (
        genConfigDetails.value.locationLevel1Name != undefined &&
        genConfigDetails.value.locationLevel1Name != ""
      ) {
        locationLevel1Name.value = genConfigDetails.value.locationLevel1Name;
      }
      if (
        genConfigDetails.value.locationLevel2Name != undefined &&
        genConfigDetails.value.locationLevel2Name != ""
      ) {
        locationLevel2Name.value = genConfigDetails.value.locationLevel2Name;
      }
      
      if (
        genConfigDetails.value.locationLevel3Name != undefined && genConfigDetails.value.locationLevel3Name !=""
      ) {
        locationLevel3Name.value = genConfigDetails.value.locationLevel3Name;
      }

    })

    const getLocationConfigDetails = () => {
      if (Object.keys(locationConfigGetter.value).length == 0) {
        settingsStore.fetchLocationConfiguration();
      } else {
        genConfigDetails.value = locationConfigGetter.value;
      }
    }
    const saveLocationConfig = (e) => {
      successtoaster.value = false;
      errortoaster.value = false;
      e.preventDefault();
      errorShow.value = false;
      var form = document.getElementById('locationConfigForm');
      const formData = new FormData(form); // reference to form element
      const postData = {}; // need to convert it before using not with XMLHttpRequest
      for (let [key, val] of formData.entries()) {
        Object.assign(postData, { [key]: val });
      }
      settingsStore.locationConfigurationSubmit(postData).then(  
        response => {
          successtoaster.value = true;
          successMessage.value = response;
          setTimeout(
            function() {
              successtoaster.value = false;
            }.bind(this),
            2000
          );
        },
        error => {
          errortoaster.value = true;
          errorMessage.value = error;
          setTimeout(
            function() {
              errortoaster.value = false;
            }.bind(this),
            15000
          );
          console.log(error);
        }
      );
    }

</script>
